import { render, staticRenderFns } from "./ListICDX.vue?vue&type=template&id=1f8c82b6"
import script from "./ListICDX.vue?vue&type=script&lang=js"
export * from "./ListICDX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8c82b6')) {
      api.createRecord('1f8c82b6', component.options)
    } else {
      api.reload('1f8c82b6', component.options)
    }
    module.hot.accept("./ListICDX.vue?vue&type=template&id=1f8c82b6", function () {
      api.rerender('1f8c82b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/icdx/ListICDX.vue"
export default component.exports